
export const dateToString = (date) => {
  if (!date) return '';
  let year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  year = '0'.repeat(4 - year.length).concat(year);
  month = '0'.repeat(2 - month.length).concat(month);
  day = '0'.repeat(2 - day.length).concat(day);
  return ''.concat(year, month, day);
}


export const getQIDOStudyDate = (studyDateFrom, studyDateTo) => {

  if (studyDateFrom && studyDateTo) {
    const dateFrom = dateToString(new Date(studyDateFrom));
    const dateTo = dateToString(new Date(studyDateTo));
    return `${dateFrom}-${dateTo}`;
  }

  return '';
}

/**
 * Produces a QIDO URL given server details and a set of specified search filter
 * items
 *
 * @param queryFilters
 * @param serverSupportsQIDOIncludeField
 * @param PACS_WITHOUT_WILDCARD
 * @returns {string} The URL with encoded filter query data
 */
export const getQIDOQueryParams = (queryFilters, serverSupportsQIDOIncludeField, PACS_WITHOUT_WILDCARD = false) => {
    const commaSeparatedFields = [
      '00081030', // Study Description
      '00080060', // Modality
      // Add more fields here if you want them in the result
    ].join(',');
    const queryParams = { ...queryFilters };
    const removeWildcards = PACS_WITHOUT_WILDCARD === true;
    if (removeWildcards) {
      Object.keys(queryParams).forEach((key) => {
        if (typeof queryParams[key] === 'string') {
          queryParams[key] = queryParams[key].replace(/\*/g, '');
        }
      });
    }

    // Build the StudyInstanceUID parameter
    // if (queryParams.StudyInstanceUID) {
    //   let studyUIDs = queryFilters.StudyInstanceUID;
    //   studyUIDs = Array.isArray(studyUIDs) ? studyUIDs.join() : studyUIDs;
    //   studyUIDs = studyUIDs.replace(/[^0-9.]+/g, '\\');
    //   queryParams.StudyInstanceUID = studyUIDs;
    // }

    queryParams.includefield = serverSupportsQIDOIncludeField ? commaSeparatedFields : 'all';

    // Clean query params of undefined values.
    const params = {};
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] !== undefined) {
        params[key] = queryParams[key];
      }
    });

    return params;
}
